// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Auto Suggest */
.auto-suggest-contain {
  border: 2px solid #A7A9AC;
  border-radius: 10px;
  width: 500px;
  position: absolute;
  overflow-x: hidden;
  background: #ffffff;
  max-height: 500px;
  min-height: 200px;
  z-index: 2000;
}

.auto-suggest button {
  text-align: left;
}
.auto-suggest button:hover {
  text-decoration: underline;
}

.option-list-ul {
  list-style-type: none;
  padding-left: 0px !important;
  margin-bottom: 20px;
}

.option-close-button {
  padding: 10px 30px;
  display: flex;
  justify-content: flex-end;
}

.option-result-container {
  width: 450px;
  display: flex;
  justify-content: space-between;
}

.chosen-student-search-container {
  display: flex;
}
.chosen-student-search-container .chosen-student-container {
  border-radius: 5px;
  display: flex;
  align-items: center;
  background: white;
  min-height: 32px;
  padding: 0 5px;
  min-width: 500px;
  margin-right: -20px;
}
.chosen-student-search-container .chosen-student-container .chosen-student-text {
  font-size: 16px;
  font-weight: 500;
  color: #0669B3;
}

.chosen-employee-search-container {
  display: flex;
}
.chosen-employee-search-container .chosen-employee-container {
  border-radius: 5px;
  display: flex;
  align-items: center;
  background: white;
  min-height: 32px;
  padding: 0 5px;
  min-width: 500px;
  margin-right: -20px;
}
.chosen-employee-search-container .chosen-employee-container .chosen-employee-text {
  font-size: 16px;
  font-weight: 500;
  color: #0669B3;
}

.overall-permissions-container {
  border-radius: 5px;
  background: white;
  color: #0669B3;
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  padding: 30px;
}

.right-permissions-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.right-permissions-container .location-icon-container {
  cursor: pointer;
}

.no-location-container {
  border-radius: 5px;
  background: white;
  color: #0669B3;
  max-width: 1200px;
  padding: 30px;
}
.no-location-container .no-location-school-drop {
  margin-top: 20px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  max-width: 500px;
  border: none;
}
.no-location-container .no-location-school-drop select {
  border: 2px solid #D1D3D4;
  border-radius: 5px;
  width: 100%;
  padding: 0.5em 3.5em 0.5em 1em;
}

.location-incorrect-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 155px;
  margin-top: 20px;
}

.incorrect-text {
  font-size: 14px;
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/StudentAutoSuggest.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANA,iBAAA;AACA;EACI,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;AASJ;;AANI;EACI,gBAAA;AASR;AARQ;EACI,0BAAA;AAUZ;;AALA;EACI,qBAAA;EACA,4BAAA;EACA,mBAAA;AAQJ;;AALA;EACI,kBAAA;EACA,aAAA;EACA,yBAAA;AAQJ;;AALA;EACI,YAAA;EACA,aAAA;EACA,8BAAA;AAQJ;;AALA;EACI,aAAA;AAQJ;AANI;EC3CA,kBD4C0B;EACtB,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAQR;AANQ;EACI,eAAA;EACA,gBAAA;EACA,cD1BC;ACkCb;;AAJA;EACI,aAAA;AAOJ;AALI;EC/DA,kBDgE0B;EACtB,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAOR;AALQ;EACI,eAAA;EACA,gBAAA;EACA,cD9CC;ACqDb;;AAFA;ECjFI,kBDkFsB;EACtB,iBAAA;EACA,cDtDS;ECuDT,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,aAAA;AAKJ;;AAFA;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;AAKJ;AAJI;EACI,eAAA;AAMR;;AAFA;ECpGI,kBDqGsB;EACtB,iBAAA;EACA,cDzES;EC0ET,iBAAA;EACA,aAAA;AAKJ;AAHI;EACI,gBAAA;EC5GJ,kBD6G0B;EACtB,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AAKR;AAJQ;EACI,yBAAA;ECnHR,kBDoH8B;EACtB,WAAA;EACA,8BAAA;AAMZ;;AAFA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;AAKJ;;AAHA;EACI,eAAA;EACA,eAAA;AAMJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n\n/* Auto Suggest */\n.auto-suggest-contain {\n    border: 2px solid $grey2;\n    border-radius: 10px;\n    width: 500px;\n    position: absolute;\n    overflow-x: hidden;\n    background: #ffffff;\n    max-height: 500px;\n    min-height: 200px;\n    z-index: 2000;\n}\n.auto-suggest {\n    button {\n        text-align: left;\n        &:hover {\n            text-decoration: underline;\n        }\n    }\n}\n\n.option-list-ul {\n    list-style-type: none;\n    padding-left: 0px !important;\n    margin-bottom: 20px;\n}\n\n.option-close-button {\n    padding: 10px 30px;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.option-result-container {\n    width: 450px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.chosen-student-search-container {\n    display: flex;\n\n    .chosen-student-container {\n        @include borderRadius(5px);\n        display: flex;\n        align-items: center;\n        background: white;\n        min-height: 32px;\n        padding: 0 5px;\n        min-width: 500px;\n        margin-right: -20px;\n\n        .chosen-student-text {\n            font-size: 16px;\n            font-weight: 500;\n            color: $pearl-blue;\n        }\n    }\n}\n.chosen-employee-search-container {\n    display: flex;\n\n    .chosen-employee-container {\n        @include borderRadius(5px);\n        display: flex;\n        align-items: center;\n        background: white;\n        min-height: 32px;\n        padding: 0 5px;\n        min-width: 500px;\n        margin-right: -20px;\n\n        .chosen-employee-text {\n            font-size: 16px;\n            font-weight: 500;\n            color: $pearl-blue;\n        }\n    }\n}\n\n.overall-permissions-container {\n    @include borderRadius(5px);\n    background: white;\n    color: $pearl-blue;\n    display: flex;\n    justify-content: space-between;\n    max-width: 1200px;\n    padding: 30px;\n}\n\n.right-permissions-container {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    .location-icon-container {\n        cursor: pointer;\n    }\n}\n\n.no-location-container {\n    @include borderRadius(5px);\n    background: white;\n    color: $pearl-blue;\n    max-width: 1200px;\n    padding: 30px;\n\n    .no-location-school-drop {\n        margin-top: 20px;\n        @include borderRadius(5px);\n        display: flex;\n        flex-direction: column;\n        max-width: 500px;\n        border: none;\n        select {\n            border: 2px solid $grey1;\n            @include borderRadius(5px);\n            width: 100%;\n            padding: 0.5em 3.5em 0.5em 1em;\n        }\n    }\n}\n.location-incorrect-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-width: 155px;\n    margin-top: 20px;\n}\n.incorrect-text {\n    font-size: 14px;\n    margin-top: 4px;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
